import React, { useState, useEffect } from 'react';

const PortfolioShowcase = ({ mousePosition }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const tiltX = mousePosition.x ? (mousePosition.x / window.innerWidth - 0.5) * 8 : 0;
  const tiltY = mousePosition.y ? (mousePosition.y / window.innerHeight - 0.5) * 8 : 0;

  const portfolioImages = [
    {
      name: 'Premium Business Site',
      url: 'https://images.unsplash.com/photo-1634084462412-b54873c0a56d?w=1400&h=900&fit=crop&q=90',
      description: 'Modern website with clean design'
    },
    {
      name: 'E-Commerce Platform',
      url: 'https://images.unsplash.com/photo-1637502875124-eb4a9843a2fa?w=1400&h=900&fit=crop&q=90',
      description: 'Premium online store design'
    },
    {
      name: 'Professional Portfolio',
      url: 'https://images.unsplash.com/photo-1547658719-da2b51169166?w=1400&h=900&fit=crop&q=90',
      description: 'Sleek digital showcase website'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % portfolioImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [portfolioImages.length]);

  return (
    <div
      className="relative mx-auto mt-16 max-w-5xl"
      style={{
        transform: `perspective(1200px) rotateX(${-tiltY}deg) rotateY(${tiltX}deg)`,
        transition: 'transform 0.15s ease-out'
      }}
    >
      {/* Browser mockup */}
      <div className="relative rounded-xl bg-gradient-to-br from-[#1a1a1a] to-[#111111] shadow-2xl border border-[#2F6BFF]/30 overflow-hidden animate-float">
        {/* Glow effect */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#2F6BFF]/10 to-[#4DA3FF]/5 blur-3xl -z-10"></div>
        
        {/* Browser chrome */}
        <div className="bg-[#0a0a0a] px-4 py-3 border-b border-[#2F6BFF]/20 flex items-center gap-3">
          {/* Browser dots */}
          <div className="flex gap-2">
            <div className="w-3 h-3 rounded-full bg-red-500/80"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-500/80"></div>
            <div className="w-3 h-3 rounded-full bg-green-500/80"></div>
          </div>
          
          {/* URL bar */}
          <div className="flex-1 bg-[#1a1a1a] rounded-lg px-4 py-2 flex items-center gap-2 border border-[#2F6BFF]/20">
            <div className="w-4 h-4 text-[#4DA3FF]">
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <span className="text-[#9AA3B2] text-sm">{portfolioImages[currentIndex].name.toLowerCase().replace(/\s+/g, '')}.co.uk</span>
          </div>
        </div>

        {/* Website preview with carousel */}
        <div className="relative h-96 bg-[#0B0F1A] overflow-hidden">
          {portfolioImages.map((item, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-all duration-700 ${
                index === currentIndex ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
              }`}
            >
              <img
                src={item.url}
                alt={item.name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              {/* Overlay with project info */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F1A] via-transparent to-transparent flex items-end p-8">
                <div>
                  <h3 className="text-white text-2xl font-bold mb-2">{item.name}</h3>
                  <p className="text-[#9AA3B2]">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
          
          {/* Progress indicators */}
          <div className="absolute bottom-4 right-4 flex gap-2">
            {portfolioImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentIndex
                    ? 'bg-[#4DA3FF] w-8'
                    : 'bg-[#2F6BFF]/30 hover:bg-[#2F6BFF]/50'
                }`}
                aria-label={`View ${portfolioImages[index].name}`}
              />
            ))}
          </div>
        </div>

        {/* Corner accents */}
        <div className="absolute top-0 left-0 w-20 h-20 border-t-2 border-l-2 border-[#4DA3FF]/40 rounded-tl-xl"></div>
        <div className="absolute bottom-0 right-0 w-20 h-20 border-b-2 border-r-2 border-[#4DA3FF]/40 rounded-br-xl"></div>
      </div>
      
      {/* Caption */}
      <div className="text-center mt-6">
        <p className="text-[#9AA3B2] text-sm">Example websites we've built for local businesses</p>
      </div>
    </div>
  );
};

export default PortfolioShowcase;
